import { EndpointSetting } from "@/constants/app/type";
import { FlightState, TypeBaggage } from "../type";

export const callbackGetBaggage: EndpointSetting['caller'] = (
  state: FlightState,
  action: any,
  endpointName: any
) => {
  state.get_baggage.loading = false
  state.get_baggage.error = null
  state.get_baggage.success = true
  const baggageList = action.payload?.baggageList || []
  const seenByRoute: { [route: string]: Set<string> } = {}
  for (let i = 0; i < baggageList.length; i++) {
    // Spread clone — never keep the raw API row reference in store
    const baggage: TypeBaggage = { ...baggageList[i] }

    const route = `${baggage.route || `${baggage.startPoint || ""}${baggage.endPoint || ""}`}`.trim()
    if (!route) {
      continue
    }
    if (!seenByRoute[route]) {
      seenByRoute[route] = new Set(
        (state.get_baggage.data[route] || []).map((item) => {
          return `${item.code}|${item.value}|${item.name}|${item.price}|${item.currency}|${item.startPoint}|${item.endPoint}`
        })
      )
    }
    const uniqueKey = `${baggage.code}|${baggage.value}|${baggage.name}|${baggage.price}|${baggage.currency}|${baggage.startPoint}|${baggage.endPoint}`
    if (seenByRoute[route].has(uniqueKey)) {
      continue
    }
    seenByRoute[route].add(uniqueKey)

    if (!state.get_baggage.data[route]) {
      state.get_baggage.data[route] = [{
        ...baggage,
        extra: 50000,
        price: parseFloat(`${baggage.price}`) + 50000,
        index: i
      }]
    } else {
      state.get_baggage.data[route].push({
        ...baggage,
        extra: 50000,
        price: parseFloat(`${baggage.price}`) + 50000,
        index: i
      })
    }
  }
}